import * as React from "react";
import type { SVGProps } from "react";

const SvgPartyHorn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <g clipPath="url(#party-horn_svg__a)">
      <path
        fill="#142745"
        d="M1.749 1.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m22.75 7a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0m1.75 14a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5M9.132 8.367a1.307 1.307 0 0 1 0-1.854l.454-.454a5.7 5.7 0 0 0 1.63-3.396l.163-1.498a1.323 1.323 0 0 1 1.455-1.16 1.307 1.307 0 0 1 1.16 1.45l-.165 1.498a8.3 8.3 0 0 1-2.384 4.96l-.454.454a1.307 1.307 0 0 1-1.854 0zm10.5 8.64.448-.453a8.3 8.3 0 0 1 4.96-2.384l1.499-.165a1.31 1.31 0 0 1 1.449 1.16 1.31 1.31 0 0 1-1.16 1.45l-1.498.163a5.7 5.7 0 0 0-3.396 1.63l-.443.46a1.312 1.312 0 0 1-1.854-1.854zM27.687.466c.47.552.4 1.384-.153 1.848l-.547.465a4.32 4.32 0 0 1-2.898 1.017 1.69 1.69 0 0 0-1.729 1.586l-.098 1.64a4.315 4.315 0 0 1-4.419 4.059 1.67 1.67 0 0 0-1.132.399l-.547.465a1.31 1.31 0 0 1-1.848-.153 1.315 1.315 0 0 1 .153-1.849l.547-.465a4.32 4.32 0 0 1 2.898-1.017 1.69 1.69 0 0 0 1.728-1.586l.099-1.64a4.314 4.314 0 0 1 4.419-4.058c.415.01.82-.131 1.132-.4l.547-.464a1.31 1.31 0 0 1 1.848.153M8.235 11.015l8.75 8.75a1.75 1.75 0 0 1 .47 1.607 1.76 1.76 0 0 1-1.094 1.269l-2.17.815-9.648-9.647.815-2.171c.208-.558.69-.968 1.269-1.094a1.76 1.76 0 0 1 1.608.47m-5.6 7.885 1.236-3.292 8.52 8.52-3.292 1.236zm-.673 1.8L7.3 26.036 2.36 27.89c-.64.24-1.367.082-1.854-.4a1.75 1.75 0 0 1-.399-1.853l1.849-4.939z"
      />
    </g>
    <defs>
      <clipPath id="party-horn_svg__a">
        <path fill="#fff" d="M0 0h28v28H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgPartyHorn;
